<template>
  <kst-section collapsible collapsed info-mode
    :help-collapsed="sectionHelp"
    :title="sectionTitle"
  >
    <kst-output field="name" :data="data" :catalog="Catalog"/>
    <kst-output field="address" :data="data" :catalog="Catalog"/>
  </kst-section>
</template>

<script>
import Catalog from "../CompanyCatalog.js";
import Info from "../CompanyInfo.js";
import Model from "../CompanyModel.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    sectionHelp() {
      return Model.getSectionHelp_RelatedDetails(this.data);
    },
    sectionTitle() {
      return Info.Section.RelatedDetails.Title;
    }
  }
}
</script>